
import { ref, defineComponent } from "vue";
import TodoList from "@/components/TodoList.vue";
import QrIcon from "@/components/QrIcon.vue";
import QrCode from "@/components/QrCode.vue";

export default defineComponent({
  name: "App",
  components: { TodoList, QrCode, QrIcon },
  props: {},
  setup() {
    const loc = ref(window.location.toString());
    window.addEventListener("hashchange", () => {
      loc.value = window.location.toString();
    });
    const showQr = ref(false);

    return { loc, showQr };
  },
});
